import React from 'react';

export const styles = () => {
  return {
    chipContainer: {
      display: 'flex',
      borderWidth: 1,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row' as 'row',
      width: 'auto',
      padding: '4px 8px',
      gap: 4,
      height: 'fit-content',
    } as React.CSSProperties,
    iconContainer: {
      width: 16,
      height: 16,
    } as React.CSSProperties,
  };
};
